export default {
      id: "icon-pencil-usage",
      viewBox: "0 0 528.899 528.899",
      url: "/" + "assets/sprite.svg#icon-pencil",
      toString: function () {
        return this.url;
      }
    }